<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="350">
            <v-card flat> 
                <v-card-title>
                    {{$t('print')}}
                </v-card-title>
                <v-card-text>
                    {{ $t('print_msg_payment_collaction') }}
                    <div id="printPaymentCollection" style="display: none">
                        <div class="row">
                            <div class="col-sm">  
                                <div>
                                    <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                    <h4 class="text-left"><p>Payment Collection Report</p></h4>
                                    <p class="text-left">khartoum - sudan Industrial Area, Gabra Square.</p>
                                    <p class="text-left"> +249912809360-+249187114000</p>
                                </div>
                                <div style="float: left;">
                                </div>
                            </div>
                            <div class="col-sm">
                                <img style="margin-left: 30px;" class="text-left"  width="150" src="../../assets/petralogo.png" alt="">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-sm"> 
                                <div class="text-left">
                                    <b>  Date:  {{ openParams.from }}   to  {{ openParams.to }}  </b>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div v-if="openParams" class="row">
                            <div class="col-sm">
                                <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>{{ $t('code') }}</th>
                                            <th>{{ $t('customers') }}</th>
                                            <th>{{ $t('phone') }}</th>
                                            <th>{{ $t('adderss') }}</th>
                                            <th>{{ $t('balance') }}</th>
                                            <th>{{ $t('last_transaction') }}</th>
                                            <th>{{ $t('sale_person') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(paymentCollection, index) in openParams.data" :key="index">
                                            <td>{{ paymentCollection.code }}</td>
                                            <td>{{ paymentCollection.name }}</td>
                                            <td>{{ paymentCollection.phone }}</td>
                                            <td>{{ paymentCollection.address }}</td>
                                            <td>{{ formatPrice(paymentCollection.balance) }}</td>
                                            <td style="width: 130px">{{ paymentCollection.last_transaction_date }}</td>
                                            <td style="width: 130px">{{ paymentCollection.sales_person }}</td>
                                        </tr>
                                        <tr>
                                            <th colspan="3"></th>
                                            <th>{{ $t('total') }}</th>
                                            <th>{{ formatPrice(openParams.total) }}</th>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import formatPrice from '@/utils/formatPrice';
export default {
    name: "PaymentCollectionReportPrintDialog",
    components: {
        
    },
    data() {
        return {
            openParams: {},
            display: false,
        }
    },
    computed: {
        
    },
    methods: {
        formatPrice,
        open(params) {
            this.openParams = params;
            this.display = true;
        },
        print() {
            this.$htmlToPaper("printPaymentCollection");
            this.close();
        },
        close() {
            this.display = false;
        }
    }
}
</script>